var K = Object.create,
  f = Object.defineProperty,
  R = Object.getPrototypeOf,
  E = Object.prototype.hasOwnProperty,
  A = Object.getOwnPropertyNames,
  G = Object.getOwnPropertyDescriptor,
  I = Object.getOwnPropertySymbols,
  J = Object.prototype.propertyIsEnumerable;
var S = Object.assign,
  O = e => f(e, "__esModule", {
    value: !0
  });
var m = (e, n) => {
  var l = {};
  for (var r in e) E.call(e, r) && n.indexOf(r) < 0 && (l[r] = e[r]);
  if (e != null && I) for (var r of I(e)) n.indexOf(r) < 0 && J.call(e, r) && (l[r] = e[r]);
  return l;
};
var L = (e, n) => {
    for (var l in n) f(e, l, {
      get: n[l],
      enumerable: !0
    });
  },
  Q = (e, n, l) => {
    if (n && typeof n == "object" || typeof n == "function") for (let r of A(n)) !E.call(e, r) && r !== "default" && f(e, r, {
      get: () => n[r],
      enumerable: !(l = G(n, r)) || l.enumerable
    });
    return e;
  },
  P = e => Q(O(f(e != null ? K(R(e)) : {}, "default", e && e.__esModule && "default" in e ? {
    get: () => e.default,
    enumerable: !0
  } : {
    value: e,
    enumerable: !0
  })), e);
O(exports);
L(exports, {
  blockContentToPlainText: () => Z,
  default: () => X
});
var w = P(require("react")),
  t = P(require("prop-types")),
  s = P(require("@sanity/block-content-to-react")),
  z = s.default.defaultSerializers,
  q = y => {
    var {
        content: e,
        className: n,
        serializers: l = {},
        dataset: r,
        projectId: p
      } = y,
      T = m(y, ["content", "className", "serializers", "dataset", "projectId"]);
    if (!e) throw new Error("No `content` provided to PortableText.");
    return w.default.createElement(s.default, S({
      blocks: e,
      className: n,
      serializers: V(l),
      renderContainerOnSingleChild: !0,
      dataset: r,
      projectId: p
    }, T));
  },
  X = q;
q.propTypes = {
  content: t.default.array.isRequired,
  className: t.default.string,
  projectId: t.default.string,
  dataset: t.default.string,
  ignoreUnknownTypes: t.default.bool,
  serializers: t.default.shape({
    link: t.default.elementType,
    strong: t.default.elementType,
    em: t.default.elementType,
    underline: t.default.elementType,
    del: t.default.elementType,
    code: t.default.elementType,
    ul: t.default.elementType,
    ol: t.default.elementType,
    li: t.default.elementType,
    h1: t.default.elementType,
    h2: t.default.elementType,
    h3: t.default.elementType,
    h4: t.default.elementType,
    h5: t.default.elementType,
    h6: t.default.elementType,
    blockquote: t.default.elementType,
    container: t.default.elementType,
    block: t.default.elementType,
    span: t.default.elementType,
    hardBreak: t.default.elementType,
    unknownType: t.default.elementType,
    unknownMark: t.default.elementType
  })
};
var V = e => {
    let {
        link: n,
        strong: l,
        em: r,
        underline: p,
        del: T,
        code: y,
        ul: a,
        ol: B,
        li: u,
        h1: k,
        h2: h,
        h3: C,
        h4: N,
        h5: g,
        h6: j,
        blockquote: x,
        container: M = "div",
        block: U = z.BlockSerializer,
        span: W = z.SpanSerializer,
        hardBreak: $ = z.HardBreakSerializer,
        unknownType: D = z.DefaultUnknownTypeSerializer,
        unknownMark: F = "span"
      } = e,
      b = m(e, ["link", "strong", "em", "underline", "del", "code", "ul", "ol", "li", "h1", "h2", "h3", "h4", "h5", "h6", "blockquote", "container", "block", "span", "hardBreak", "unknownType", "unknownMark"]),
      _ = {
        h1: k,
        h2: h,
        h3: C,
        h4: N,
        h5: g,
        h6: j,
        blockquote: x
      };
    return {
      container: M,
      block: U,
      span: W,
      hardBreak: $,
      unknownType: D,
      unknownMark: F,
      marks: Y(S({
        link: n,
        strong: l,
        em: r,
        underline: p,
        code: y,
        "strike-through": T
      }, b)),
      list: o => {
        let {
            type: i,
            children: c
          } = o,
          d = i === "bullet" ? a : B;
        return d ? d({
          children: c
        }) : s.default.defaultSerializers.list(o);
      },
      listItem: o => {
        let {
          children: i
        } = o;
        return u ? u({
          children: i
        }) : s.default.defaultSerializers.listItem(o);
      },
      types: S({
        block: o => {
          let {
            node: {
              style: i
            },
            children: c
          } = o;
          return _[i] ? _[i]({
            children: c
          }) : b[i] ? b[i]({
            children: c
          }) : s.default.defaultSerializers.types.block(o);
        }
      }, Object.entries(b).reduce((o, _ref) => {
        let [i, c] = _ref;
        let d = _ref2 => {
          let {
            node: H
          } = _ref2;
          return w.default.createElement(c, H);
        };
        return d.displayName = "".concat(v(i), "Wrapper"), o[i] = d, o;
      }, {}))
    };
  },
  Y = e => Object.entries(e).reduce((n, _ref3) => {
    let [l, r] = _ref3;
    if (r) {
      let p = h => {
        var {
            _type: T,
            _key: y,
            mark: a,
            markKey: B,
            children: u
          } = h,
          k = m(h, ["_type", "_key", "mark", "markKey", "children"]);
        if (typeof a == "object") {
          let {
              _type: C,
              _key: N
            } = a,
            g = m(a, ["_type", "_key"]);
          Object.entries(g).forEach(_ref4 => {
            let [j, x] = _ref4;
            k[j] = x;
          });
        }
        return w.default.createElement(r, k, u);
      };
      p.displayName = "".concat(v(l), "Wrapper"), n[l] = p;
    }
    return n;
  }, {}),
  Z = function () {
    let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return e.map(n => n._type === "block" && n.children ? n.children.map(l => l.text).join("") : "").join("\n\n");
  },
  v = e => e.slice(0, 1).toUpperCase() + e.slice(1);